import { render } from "./Task.vue?vue&type=template&id=62c7f67f&ts=true"
import script from "./Task.vue?vue&type=script&lang=ts"
export * from "./Task.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__